import DB from './DB'

const filterKeys = {
  'productid': 'productid',
  'brand': 'brand',
  'product': 'name',
  'period': 'period',
}

class ProductDB extends DB {
  constructor(array = [], options) {
    super(array, filterKeys, options)
  }
}

export default ProductDB